import React from 'react';
import OverzichtPortfolios from '../../components/portfolios/Overzicht';

const PagePortfolioOverzicht: React.FC = () => {

  return (
    <>
      <header className="app-header">
        <h1>Afstemmingsdossiers</h1>
        <p className="header-sub-title center">
          Overzicht van alle afstemmingsdossiers waarin u deelneemt.
        </p>
      </header>

      <div className="content">
        <OverzichtPortfolios />
      </div>
    </>
  );
};

export default PagePortfolioOverzicht;